module.exports = __webpack_public_path__ + "static/media/10.9f4c2076.jpg";